import MothershipClient from '../mothershipClient';

export class AuthClient {
  getArkkeoUser({ email, password }) {
    return MothershipClient.post(
      '/auth/app?source=WEBAPP',
      { email, password },
      { isLoginRequest: true },
    );
  }
}

export default new AuthClient();
